import { ref } from 'vue';

const toasts = ref([]);
let idCounter = 0;

export function useToast() {
  const showToast = (message, type = 'info', duration = 3000) => {
    const id = ++idCounter;
    const toast = { id, message, type, show: false };
    toasts.value.push(toast);

    requestAnimationFrame(() => {
      toast.show = true;
    });

    setTimeout(() => {
      toast.show = false;
      setTimeout(() => {
        const idx = toasts.value.findIndex(t => t.id === id);
        if (idx > -1) toasts.value.splice(idx, 1);
      }, 400);
    }, duration);
  };

  return { toasts, showToast };
}
